import { Text, Tabs, Box, Container, Flex, Heading, Button } from "@radix-ui/themes";
import ExploreContent from "./Explore";
import { useNavigate } from "react-router-dom";

const Admin = () => {
	const navigate = useNavigate();

	const handleLogout = async () => {
		try {
			await fetch('/v1/auth/admin/logout', { method: 'POST' });
			navigate('/admin/login');
		} catch (err) {
			console.error('Logout failed', err);
		}
	};

	return (
		<Box>
			<Container size="4">
				<Tabs.Root defaultValue="explore">
					<Tabs.List style={{ display: 'flex', width: '100%' }}>
						<Box px="2"><Text size="6">
							<Flex direction="row" align="center" style={{ height: '100%' }}>
								<Text weight="light">LiveFootball</Text>
								<Text weight="bold">OnTV</Text>
							</Flex>
						</Text>
						</Box>
						<Tabs.Trigger value="explore">Trending Topics</Tabs.Trigger>
						<Tabs.Trigger value="settings">App Settings</Tabs.Trigger>
						<Box style={{ flexGrow: 1 }} />
						<Box px="2" style={{ display: 'flex', alignItems: 'center' }}>
							<Button color="red" variant="soft" onClick={handleLogout}>Logout</Button>
						</Box>
					</Tabs.List>

					<Box pt="3">
						<Tabs.Content value="explore">
							<ExploreContent />
						</Tabs.Content>

						<Tabs.Content value="settings">
							<Text size="2">Edit killswitch, sync period, competition mode</Text>
						</Tabs.Content>
					</Box>
				</Tabs.Root>
			</Container>
		</Box>
	);
};

export default Admin;
